module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"description":"LIS Prod","manifest_version":2,"name":"lis-prod-front","version":"1.1","start_url":"/","display":"standalone","homepage_url":"https://github.com/mdn/webextensions-examples/tree/master/latest-download","icon":"src/images/icon.png","permissions":["downloads","downloads.open","notifications"],"cache_busting_mode":"none","legacy":true,"theme_color_in_head":true,"crossOrigin":"anonymous","include_favicon":true,"cacheDigest":null},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
